import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { PreOrderListModel, PreOrderListModelList } from '../models/models'

export class CheckPreOrderListAuthApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/auth/PreOrderAdminAuth',
      requesterInfo,
    })
  }

  public async check(): Promise<boolean> {
    return await this.getAsync<boolean>()
  }
}
